package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class WebEmailVerificationClientRequestInfo(val emailVerificationToken: String)